<div
  class="glass-container p-6 max-w-[1600px] mx-auto space-y-6 text-slate-800 dark:text-slate-200 animate-fade-in relative min-h-[85vh]">

  <!-- Decorative Backdrop Blobs for Glassmorphism highlights -->
  <!-- <div
    class="absolute top-10 left-1/4 w-80 h-80 bg-amber-400/10 dark:bg-amber-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
    style="animation-duration: 8s;"></div> -->
  <div
    class="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-400/10 dark:bg-blue-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
    style="animation-duration: 12s;"></div>

  <!-- ================= Header Section ================= -->
  <div class="flex flex-col md:flex-row md:items-center justify-between gap-6 pb-2">
    <div class="space-y-1">
      <h1
        class="text-2xl md:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.3)]">
          <span class="material-icons">type_specimen</span>
        </div>
        ตั้งค่าประเภทเรื่องปัญหา
      </h1>
      <p class="text-xs text-slate-500 dark:text-slate-400 font-medium pl-13">
        ตั้งค่าประเภทเรื่องปัญหา (Issue Type) รูปแบบการจัดการ และเวลาดำเนินการเป้าหมาย (SLA)
      </p>
    </div>

    <!-- Create Button -->
    <button *ngIf="canCreate" (click)="openCreate()"
      class="group flex items-center gap-2 px-5 py-2.5 bg-amber-400 hover:bg-amber-500 text-slate-900 font-black rounded-2xl text-xs shadow-md transition-all duration-300 hover:scale-[1.02] hover:shadow-amber-500/20 border-none cursor-pointer">
      <span class="material-icons text-sm transition-transform duration-300 group-hover:rotate-90">add</span>
      สร้างประเภทปัญหาใหม่
    </button>
  </div>

  <!-- ================= Main Panel ================= -->
  <div class="glass-panel rounded-3xl p-6 space-y-6">

    <!-- Table Control Bar -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4">

      <div class="flex flex-wrap items-center gap-3 w-full sm:w-auto">
        <!-- Search Field with Type Dropdown -->
        <div
          class="flex items-center bg-white/80 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2 focus-within:ring-4 focus-within:ring-amber-400/20 focus-within:border-amber-400 transition-all duration-300 shadow-sm text-xs w-full sm:max-w-xs">
          <span class="material-icons text-slate-400 mr-2.5 text-base">search</span>
          <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
            placeholder="ค้นหารหัสประเภท หรือชื่อประเภท..."
            class="w-full outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />

          <!-- Search Type Dropdown -->
          <div class="relative border-l border-slate-200/80 dark:border-slate-700/80 pl-2.5 ml-2.5">
            <button (click)="toggleSearchTypeDropdown()"
              class="flex items-center gap-1 font-bold text-slate-650 dark:text-slate-400 hover:text-amber-500 cursor-pointer transition-colors border-none bg-transparent">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-xs text-slate-400 transition-transform"
                [class.rotate-180]="isSearchTypeDropdownOpen">arrow_drop_down</span>
            </button>

            <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute right-0 mt-3 z-50 w-32 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-2xl shadow-lg py-1 animate-fade-in">
              <button (click)="selectSearchType('all')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent">ทั้งหมด</button>
              <button (click)="selectSearchType('code')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent">รหัสประเภท</button>
              <button (click)="selectSearchType('name')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent">ชื่อประเภท</button>
            </div>
          </div>
        </div>

        <!-- Filter toggle -->
        <button (click)="toggleActiveFilterDropdown()" (blur)="closeActiveFilterDropdown()"
          class="flex items-center gap-1.5 px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-650 dark:text-slate-350 font-bold rounded-2xl text-xs shadow-sm cursor-pointer transition-all duration-300 hover:scale-[1.01] relative">
          <span class="material-icons text-sm">filter_alt</span>
          <span>สถานะ: {{ activeFilterLabel }}</span>
          <span class="material-icons text-slate-400 text-sm transition-transform"
            [class.rotate-180]="isActiveFilterDropdownOpen">expand_more</span>

          <div *ngIf="isActiveFilterDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute top-full left-0 mt-2 z-50 w-36 bg-white/95 dark:bg-slate-850/95 backdrop-blur-md border border-slate-100 dark:border-slate-700/50 rounded-2xl shadow-xl py-1 animate-fade-in text-left">
            <button (click)="selectActiveFilter(null)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block border-none bg-transparent">
              ทั้งหมด
            </button>
            <button (click)="selectActiveFilter(true)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block border-none bg-transparent">
              เปิดใช้งาน (Active)
            </button>
            <button (click)="selectActiveFilter(false)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block border-none bg-transparent">
              ปิดใช้งาน (Inactive)
            </button>
          </div>
        </button>
      </div>

      <!-- Action Refresh -->
      <button (click)="loadIssueTypes()"
        class="group flex items-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-2xl text-xs shadow-sm cursor-pointer transition-all duration-300 hover:scale-[1.01] hover:shadow-amber-500/10 border-none self-end sm:self-auto">
        <span class="material-icons text-sm transition-transform duration-500 group-hover:rotate-180">refresh</span>
        รีเฟรช
      </button>
    </div>

    <!-- Table Container -->
    <div
      class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10">
      <table class="premium-table text-left text-sm">
        <thead>
          <tr
            class="bg-slate-50/60 dark:bg-slate-800/40 text-slate-500 dark:text-slate-400 font-bold text-xs uppercase tracking-wider">

            <th
              class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 rounded-tl-2xl w-24 text-center"
              (click)="sortData('sortOrder')">
              ลำดับ
              <span *ngIf="sortColumn === 'sortOrder'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('code')">
              รหัสประเภทเรื่อง
              <span *ngIf="sortColumn === 'code'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('name')">
              ชื่อประเภทเรื่อง (TH)
              <span *ngIf="sortColumn === 'name'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('category')">
              หมวดหมู่
              <span *ngIf="sortColumn === 'category'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('resolutionMode')">
              รูปแบบการแก้ไข
              <span *ngIf="sortColumn === 'resolutionMode'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 text-center"
              (click)="sortData('defaultSlaHours')">
              SLA
              <span *ngIf="sortColumn === 'defaultSlaHours'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>

            <th class="py-4 px-5 text-center">ออนไลน์</th>
            <th class="py-4 px-5 text-center">สถานะ</th>
            <th class="py-4 px-5 text-center rounded-tr-2xl">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
          <tr *ngFor="let item of issueTypes" (click)="openEdit(item)"
            class="bg-white hover:bg-slate-200/40 dark:hover:bg-slate-800/60 dark:bg-slate-800/40 cursor-pointer transition-all duration-300 animate-row-fade">
            <td class="py-4 px-5 text-center text-slate-500 dark:text-slate-400 font-bold">{{ item.sortOrder }}</td>
            <td class="py-4 px-5 font-extrabold text-slate-900 dark:text-slate-100">{{ item.code }}</td>
            <td class="py-4 px-5 font-semibold text-slate-700 dark:text-slate-300">{{ item.name }}</td>
            <td class="py-4 px-5">
              <span
                class="px-2.5 py-1 rounded-xl text-[10px] font-extrabold bg-blue-50 dark:bg-blue-950/20 text-blue-600 dark:text-blue-400 border border-blue-200/30">
                {{ getCategoryLabel(item.category) }}
              </span>
            </td>
            <td class="py-4 px-5">
              <span
                class="px-2.5 py-1 rounded-xl text-[10px] font-extrabold bg-purple-50 dark:bg-purple-950/20 text-purple-600 dark:text-purple-400 border border-purple-200/30">
                {{ getResolutionModeLabel(item.resolutionMode) }}
              </span>
            </td>
            <td class="py-4 px-5 text-center font-bold text-slate-600 dark:text-slate-400">{{ item.defaultSlaHours }}
              ชม.</td>

            <!-- Online status -->
            <td class="py-4 px-5 text-center">
              <span
                [class]="item.isOnline 
                ? 'px-3 py-1 rounded-xl text-[10px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50 dark:border-green-800/50' 
                : 'px-3 py-1 rounded-xl text-[10px] font-bold bg-slate-50 dark:bg-slate-800/50 text-slate-400 dark:text-slate-500 border border-slate-200/50 dark:border-slate-700/50'">
                {{ item.isOnline ? 'Online' : 'Offline' }}
              </span>
            </td>

            <!-- Active status -->
            <td class="py-4 px-5 text-center">
              <span
                [class]="item.active 
                ? 'px-3 py-1 rounded-xl text-[10px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50 dark:border-green-800/50' 
                : 'px-3 py-1 rounded-xl text-[10px] font-bold bg-slate-50 dark:bg-slate-800/50 text-slate-400 dark:text-slate-500 border border-slate-200/50 dark:border-slate-700/50'">
                {{ item.active ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
              </span>
            </td>

            <!-- Actions -->
            <td class="py-4 px-5 text-center" (click)="$event.stopPropagation()">
              <button (click)="openEdit(item)"
                class="group text-amber-500 hover:text-amber-600 dark:hover:text-amber-400 font-bold text-xs flex items-center justify-center gap-1.5 mx-auto cursor-pointer transition-all duration-300 border-none bg-transparent">
                <span class="material-icons text-sm">edit</span>
                <span>แก้ไข</span>
                <span
                  class="material-icons text-[10px] opacity-0 -ml-3 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300">arrow_forward</span>
              </button>
            </td>
          </tr>

          <!-- Empty search state -->
          <tr *ngIf="issueTypes.length === 0">
            <td colspan="9" class="py-16 text-center">
              <div
                class="flex flex-col items-center justify-center p-6 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-md mx-auto">
                <div
                  class="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 shadow-inner">
                  <span
                    class="material-icons text-4xl text-slate-300 dark:text-slate-600 animate-bounce">search_off</span>
                </div>
                <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-300 mb-1">ไม่พบข้อมูลประเภทเรื่องปัญหา
                </h3>
                <p class="text-xs text-slate-500 dark:text-slate-400 font-medium">ลองเปลี่ยนคำค้นหา
                  หรือกรองตามสถานะใหม่อีกครั้ง</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm border-none">
            <span>{{ pageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-850/95 backdrop-blur-md border border-slate-100 dark:border-slate-750 rounded-xl shadow-lg py-1 animate-fade-in text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectPageSize(opt)"
              class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer border-none bg-transparent">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1.5">
        <!-- Prev Page -->
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer border-none">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of pagesArray">
          <!-- Active Page -->
          <button *ngIf="page === currentPage"
            class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_14px_rgba(251,191,36,0.4)] flex items-center justify-center text-xs border-none">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== currentPage" (click)="setPage(page)"
            class="w-8 h-8 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-all flex items-center justify-center text-xs cursor-pointer border-none bg-transparent">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer border-none">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>

  </div>

  <!-- ================= MODAL COMPONENT: Form Modal ================= -->
  <app-modal-customer-service-issue-type *ngIf="isModalOpen" [editRow]="selectedIssueType" (close)="isModalOpen = false"
    (saveSuccess)="onSaved()">
  </app-modal-customer-service-issue-type>

</div>

<!-- ================= SHARED COMPONENT: Loading Overlay ================= -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>